import api from '@/services/api';
const ENTITY_ENDPOINT = 'usuario';

export class EjecutivoService {
  /**
   * Obtiene todos los ejecutivos con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los ejecutivos con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca ejecutivos por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un ejecutivo por su ID
   * @param {string|number} id - ID del ejecutivo
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo ejecutivo
   * @param {Object} ejecutivo - Datos del ejecutivo a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(ejecutivo) {
    return await api.post(`/${ENTITY_ENDPOINT}`, ejecutivo);
  }

  /**
   * Actualiza un ejecutivo existente
   * @param {string|number} id - ID del ejecutivo
   * @param {Object} ejecutivo - Datos del ejecutivo a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, ejecutivo) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, ejecutivo);
  }

  /**
   * Elimina un ejecutivo
   * @param {string|number} id - ID del ejecutivo
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Obtiene ejecutivos activos con paginación
   * @param {Object} filters - Filtros adicionales
   * @param {number} page - Página
   * @param {number} limit - Límite de elementos por página
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findActiveEjecutivos(filters = {}, page = 1, limit = 35) {
    return await api.get(`/${ENTITY_ENDPOINT}`, {
      params: {
        Activo: true,
        page,
        limit,
        ...filters,
      },
    });
  }

  /**
   * Busca ejecutivos por descripción
   * @param {string} descripcion - Descripción a buscar
   * @param {string} rolUsuario - Rol del usuario (opcional)
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async searchByDescription(descripcion, rolUsuario = null) {
    let url = `/${ENTITY_ENDPOINT}/description?page=1`;
    if (descripcion && descripcion.trim().length > 0) {
      url += `&Descripcion=${encodeURIComponent(descripcion.trim())}`;
    }
    if (rolUsuario) {
      url += `&RolUsuario=${rolUsuario}`;
    }
    return await api.get(url);
  }
}

export default EjecutivoService;
